import styled from 'styled-components';
import { formatViewport } from 'utils/get-pixels-to-viewport';

export const Container = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: ${formatViewport(24)};
    height: ${formatViewport(24, 'vh')};
  }

  path {
    fill: ${(props) => props.theme.text.primary};
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${formatViewport(8)};
  font-size: ${formatViewport(15.36)};
`;
